import * as io from 'socket.io-client';

let host = window.location.hostname;
let domain;

if (host == 'localhost' || host == 'clientdev.freightapp.com') {
    domain = 'tms-dev.freightapp.com:7771';
} else if (host == 'clientstage.freightapp.com' || host == 'shipstage.unisco.com') {
    domain = 'tms-dev.freightapp.com:7781';
} else if (
    host == 'client.freightapp.com' ||
    host == 'ship.unisco.com' ||
    host == 'demo.unisco.com'
) {
    domain = 'api.freightapp.com:7791';
}

let socket = io.connect(`https://${domain}/rate_channel`);

socket.on('connection', () => {
    // console.log("rate channel connected");
});

export default socket;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/services/socketIO/rateChannel.ts